module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// /root/anvel/~/readable-stream/writable-browser.js
// module id = ../../../../readable-stream/writable-browser.js
// module chunks = 4